export default __webpack_public_path__ + "assets/svg/download_ios.2a8620338eb1a8d4d835956436b6e380.svg";